export default __webpack_public_path__ + "static/media/fit-on-uneven-surfaces.9b259a3d.svg";